<template>
    <div class="plateorder">
        <div class="plateorder-tabs vue_flex vue_column">
            <div class="plateorder-tabs-input vue_flex vue_align_center">
                <div class="shaixuan_item vue_flex vue_flex_between vue_align_center h">
                    <div class="shaixuan_item_con vue_flex vue_align_center">
                        <img class="shaixuan_item_icon" src="../../../../../assets/ym/tjsj@2x.png" alt="" />
                        <div class="shaixuan_item_tit">统计时间</div>
                    </div>
                    <el-date-picker v-model="skulistQuery.time" type="datetimerange" range-separator=""
                        start-placeholder="" end-placeholder="" value-format="timestamp" class="vue_flex_item"
                        placeholder="选择日期" style="border: none">
                    </el-date-picker>
                </div>
                <div class="shaixuan_item vue_flex vue_flex_between vue_align_center h">
                    <div class="shaixuan_item_con vue_flex vue_align_center">
                        <img class="shaixuan_item_icon" src="../../../../../assets/ym/qd@2x.png" alt="" />
                        <div class="shaixuan_item_tit">渠道</div>
                    </div>
                    <el-select v-model="skulistQuery.type" placeholder="渠道" class="vue_flex_item">
                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="shaixuan_item vue_flex vue_flex_between vue_align_center h">
                    <div class="shaixuan_item_con vue_flex vue_align_center">
                        <img class="shaixuan_item_icon" src="../../../../../assets/ym/dp@2x.png" alt="" />
                        <div class="shaixuan_item_tit">店铺</div>
                    </div>
                    <el-select v-model="skulistQuery.shopid" placeholder="请选择" class="vue_flex_item">
                        <el-option v-for="item in dpList" :key="item.shopid" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </div>

                <div class="top_bar_inp vue_flex vue_align_center">
                    <input type="text" class="top_bar_inp_inp" v-model="skulistQuery.search" placeholder="商品ID、名称搜索" />
                </div>
            </div>

            <div class="plateorder-tabs-bottom vue_flex vue_flex_between vue_align_center">
                <div class="plateorder-tabs-bottom-text vue-font-PingFang-500 color_35"> 未设置成本商品链接 </div>
                <div class="vue_flex">
                    <div class="plateorder-tabs-input-but plain vue-font-PingFang-500 color_35 h"
                        @click="skuDiaflg = true"> 导入规格 </div>
                    <div class="plateorder-tabs-input-but plain vue-font-PingFang-500 color_35 h"
                        @click="dialogimportVisible = true"> 导入商品 </div>
                    <div class="plateorder-tabs-input-but plain vue-font-PingFang-500 color_35 h" @click="qingchu"> 清除
                    </div>
                    <div class="plateorder-tabs-input-but vue-font-PingFang-500 color_255 h" @click="getListFun"> 查询
                    </div>
                </div>
            </div>
        </div>

        <div class="width_100" style="margin-top: 28px">
            <el-table :data="dataList" style="width: 100%" :header-cell-style="headercellstyle" border height="62vh"
                :key="'taobaoTable'">
                <el-table-column prop="goodsid" label="商品ID" align="center"></el-table-column>
                <el-table-column prop="goodsname" label="商品名称" align="center"></el-table-column>
                <el-table-column prop="channel" label="渠道" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.type == "1" ? "淘宝" : scope.row.type == "2" ? "京东" : "拼多多" }}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="店铺" align="center">
                    <template slot-scope="scope" v-if="scope.row.shopinfo">
                        {{ scope.row.shopinfo.name }}
                    </template>
                </el-table-column>
                <el-table-column prop="goodscost" label="商品成本" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.goodscost }}
                        <el-button type="text" @click="openSetDia('cost', scope.row)">设置</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="stencil" label="快递模板" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="openSetDia('stencil', scope.row)">设置</el-button>
                        <!-- <el-button type="text" @click="(importText = 'stencil'), (dialogcostVisible = true)">设置</el-button> -->
                    </template>
                </el-table-column>
                <el-table-column prop="stencil" label="包装模板" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="openSetDia('packa', scope.row)">设置</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="stencil" label="赠品模板" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="openSetDia('freegift', scope.row)">设置</el-button>
                        <!-- <el-button type="text" @click="(importText = 'freegift'), (dialogcostVisible = true)">设置</el-button> -->
                    </template>
                </el-table-column>
                <el-table-column prop="stencil" label="重量模板" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="openSetDia('weight', scope.row)">设置</el-button>
                    </template>
                </el-table-column>

                <el-table-column align="center" label="操作" width="160" class-name="small-padding fixed-width">
                    <template slot-scope="row">
                        <el-button type="danger" size="small" @click="handleDelete(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination :total="total" :page.sync="skulistQuery.page" :limit.sync="skulistQuery.limit"
            @pagination="getListFun" />

        <el-dialog :visible.sync="skuDiaflg" custom-class="unique-dialog" width="752px" :close-on-click-modal="false"
            :show-close="false">
            <div class="import-mask import-shop vue_flex vue_align_center vue_column">
                <div class="import-mask-title vue-font-PingFang-500 color_255 vue_relative">
                    上传规格
                    <img src="../../../../../assets/yimou/gb.png" alt="" class="vue_absolute" @click="closeGoodsDia" />
                </div>

                <div class="import-mask-boxs-img vue_flex vue_column">
                    <img src="../../../../../assets/yimou/dyb.png" alt="" />
                    <div class="import-mask-boxs-img-view vue_flex vue_align_center vue_flex_between h">
                        <p class="vue-font-PingFang-500 color_35">导入模版</p>
                        <div class="vue-font-PingFang-500 color_255"
                            @click=" downloadModel('https://img-yimou.oss-cn-hangzhou.aliyuncs.com/1-static-moban/%E5%95%86%E5%93%81%E8%A7%84%E6%A0%BC%E6%A8%A1%E6%9D%BF%E8%A1%A8%281%29.xlsx')">
                            下载 </div>
                    </div>
                </div>

                <div class="import-mask-boxs vue_flex vue_column">
                    <div class="import-mask-boxs-upload size_no_repeat vue_flex vue_column vue_align_center">
                        <el-upload class="upload-demo" :http-request="(file) => leading(file, 'sku')" drag action
                            multiple action="/" ref="limit" :show-file-list="false">
                            <div v-if="updatafileName == ''">
                                <img src="../../../../../assets/yimou/cwj.png" alt="" />
                                <p class="upload-title vue-font-PingFang-500">
                                    <!-- <span class="color_35">将文件拖到此处，或</span> -->
                                    <span>点击上传</span>
                                </p>
                                <p class="upload-content vue-font-PingFang-500 color_94">
                                    只能上传 excel 文件
                                </p>
                            </div>
                            <div v-else>
                                <img src="../../../../../assets/ym/excel.png" alt="" class="file-icon" />
                                <div style="margin-top: 30px">{{ fileName }}</div>
                            </div>
                        </el-upload>
                    </div>
                </div>
                <div class="import-mask-but vue-font-PingFang-500 color_255" @click="toApplySku">
                    确认上传
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="dialogimportVisible" custom-class="unique-dialog" width="752px"
            :close-on-click-modal="false" :show-close="false">
            <div class="import-mask import-shop vue_flex vue_align_center vue_column">
                <div class="import-mask-title vue-font-PingFang-500 color_255 vue_relative">
                    导入商品
                    <img src="../../../../../assets/yimou/gb.png" alt="" class="vue_absolute" @click="closeGoodsDia" />
                </div>
                <div class="import-mask-boxs vue_flex vue_column">
                    <div class="import-mask-boxs-inp">
                        <ul class="vue_flex vue_align_center">
                            <li class="vue_flex vue-font-PingFang-500">
                                <span>*</span>
                                <p class="color_35">渠道选择</p>
                            </li>
                            <li class="import-mask-ul-boxs">
                                <el-select v-model="tempObj.channelVal" placeholder="请选择">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </li>
                        </ul>
                    </div>
                    <div class="import-mask-boxs-inp">
                        <ul class="vue_flex vue_align_center">
                            <li class="vue_flex vue-font-PingFang-500">
                                <span>*</span>
                                <p class="color_35">店铺选择</p>
                            </li>
                            <li class="import-mask-ul-boxs">
                                <el-select v-model="tempObj.shopid" placeholder="请选择">
                                    <el-option v-for="item in dpList" :key="item.shopid" :label="item.name"
                                        :value="item.id"></el-option>
                                </el-select>
                            </li>
                        </ul>
                    </div>

                    <div class="import-mask-boxs-img vue_flex vue_column">
                        <img src="../../../../../assets/yimou/dyb.png" alt="" />
                        <div class="import-mask-boxs-img-view vue_flex vue_align_center vue_flex_between h">
                            <p class="vue-font-PingFang-500 color_35">导入模版</p>
                            <div class="vue-font-PingFang-500 color_255"
                                @click="downloadModel('https://img.yimoubi.com/1-static-moban/%E5%95%86%E5%93%81%E6%A8%A1%E6%9D%BF%E8%A1%A8.xlsx')">
                                下载
                            </div>
                        </div>
                    </div>

                    <div class="import-mask-boxs-img vue_flex vue_column">
                        <img src="../../../../../assets/yimou/scsp.png" alt="" />
                        <p class="import-mask-boxs-img-text vue-font-PingFang-500 color_153">
                            下载模板配置商品成本后，请上传Excel
                        </p>
                    </div>

                    <div class="import-mask-boxs-upload size_no_repeat vue_flex vue_column vue_align_center">
                        <el-upload class="upload-demo" :http-request="(file) => leading(file, 'goods')" drag action
                            multiple action="/" ref="limit" :show-file-list="false">
                            <div v-if="updatafileName == ''">
                                <img src="../../../../../assets/yimou/cwj.png" alt="" />
                                <p class="upload-title vue-font-PingFang-500">
                                    <!-- <span class="color_35">将文件拖到此处，或</span> -->
                                    <span>点击上传</span>
                                </p>
                                <p class="upload-content vue-font-PingFang-500 color_94">
                                    只能上传 excel 文件
                                </p>
                            </div>
                            <div v-else>
                                <img src="../../../../../assets/ym/excel.png" alt="" class="file-icon" />
                                <div style="margin-top: 30px">{{ fileName }}</div>
                            </div>
                        </el-upload>
                    </div>
                </div>
                <div class="import-mask-but vue-font-PingFang-500 color_255" @click="toApplyGoods">
                    确认上传
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="dialogcostVisible" custom-class="unique-dialog" width="1496px"
            :close-on-click-modal="false" :show-close="false" top="5vh">
            <div class="import-mask cost-shop vue_flex vue_align_center vue_column">
                <div class="import-mask-title vue-font-PingFang-500 color_255 vue_relative">
                    {{ importTextFun(importText) }}
                    <img src="../../../../../assets/yimou/gb.png" alt="" class="vue_absolute"
                        @click="dialogcostVisible = false" />
                </div>
                <div class="cost-shop-boxs vue_flex vue_column width_100">
                    <div class="cost-shop-boxs-input vue_flex" v-if="importText === 'cost'">
                        <div class="cost-shop-boxs-input-item vue_flex vue_align_center">
                            <img class="top_bar_inp_img1 h" src="../../../../../assets/yimou/ss.png" alt="" />
                            <input type="text" class="vue_flex_item" v-model="skulistQuery.search"
                                placeholder="搜索SKU名称、ID" />
                        </div>
                        <div class="shaixuan_item vue_flex vue_align_center h">
                            <div class="shaixuan_item_con vue_flex vue_align_center">
                                <p class="vue-font-PingFang-500 color_35">价格</p>
                            </div>
                            <div class="shaixuan_item_con vue_flex vue_align_center">
                                <p class="vue-font-PingFang-500 color_153">
                                    <input type="text" v-model="skulistQuery.minprice"
                                        style="width: 40px; background: #eee" placeholder="请输入" />
                                </p>
                                <p class="vue-font-PingFang-500 color_153">~</p>
                                <p class="vue-font-PingFang-500 color_153">
                                    <input type="text" v-model="skulistQuery.maxprice"
                                        style="width: 40px; background: #eee" placeholder="请输入" />
                                </p>
                            </div>
                        </div>
                        <div class="shaixuan_item vue_flex vue_align_center h">
                            <div class="shaixuan_item_con vue_flex vue_align_center">
                                <p class="vue-font-PingFang-500 color_35">成本</p>
                            </div>
                            <div class="shaixuan_item_con vue_flex vue_align_center">
                                <p class="vue-font-PingFang-500 color_153">
                                    <input type="text" v-model="skulistQuery.minchengben"
                                        style="width: 40px; background: #eee" placeholder="请输入" />
                                </p>
                                <p class="vue-font-PingFang-500 color_153">~</p>
                                <p class="vue-font-PingFang-500 color_153">
                                    <input type="text" v-model="skulistQuery.maxchengben"
                                        style="width: 40px; background: #eee" placeholder="请输入" />
                                </p>
                            </div>
                        </div>
                        <div class="cost-shop-boxs-input-item vue_flex vue_align_center">
                            <div class="plateorder-tabs-input-but-search vue-font-PingFang-500 color_255 h"
                                @click="getSkuList">
                                查询
                            </div>
                        </div>
                    </div>
                    <div class="cost-shop-boxs-input vue_flex" v-if="
                        importText === 'stencil' ||
                        importText === 'packa' ||
                        importText === 'freegift'
                    ">
                        <div class="vue_flex vue_align_center">
                            <p class="vue-font-PingFang-500 color_35" style="font-size: 24px">
                                模板设置
                            </p>
                            <img src="../../../../../assets/yimou/wh.png" alt=""
                                style="width: 24px; height: 24px; margin: 0px 38px 0px 11px" />
                        </div>

                    </div>
                    <div class="cost-shop-boxs-input vue_flex" v-if="importText === 'weight'">
                        <div class="cost-shop-boxs-input-item vue_flex vue_align_center">
                            <img class="top_bar_inp_img1 h" src="../../../../../assets/yimou/ss.png" alt="" />
                            <input type="text" class="vue_flex_item" v-model="skulistQuery.search"
                                placeholder="搜索SKU名称、ID" />
                        </div>
                        <div class="shaixuan_item vue_flex vue_align_center h">
                            <div class="shaixuan_item_con vue_flex vue_align_center">
                                <p class="vue-font-PingFang-500 color_35">重量</p>
                            </div>
                            <div class="shaixuan_item_con vue_flex vue_align_center">
                                <p class="vue-font-PingFang-500 color_153">
                                    <input type="text" v-model="skulistQuery.minzhongliang"
                                        style="width: 40px; background: #eee" placeholder="请输入" />
                                </p>
                                <p class="vue-font-PingFang-500 color_153">~</p>
                                <p class="vue-font-PingFang-500 color_153">
                                    <input type="text" v-model="skulistQuery.maxzhongliang"
                                        style="width: 40px; background: #eee" placeholder="请输入" />
                                </p>
                            </div>
                        </div>
                        <div class="cost-shop-boxs-input-item vue_flex vue_align_center">
                            <div class="plateorder-tabs-input-but-search vue-font-PingFang-500 color_255 h"
                                @click="getSkuList">
                                查询
                            </div>
                        </div>
                    </div>
                    <div class="width_100">
                        <el-table :data="costList" style="width: 100%" :header-cell-style="headercellstyle" border
                            height="60vh" :key="'costTable'" v-if="importText === 'cost'">
                            <el-table-column prop="goodsname" label="SKU" align="center"></el-table-column>
                            <el-table-column prop="skuid" label="skuid" align="center"></el-table-column>
                            <el-table-column prop="uid" label="uid" align="center"></el-table-column>
                            <el-table-column prop="price" label="价格 批量设置" align="center">
                                <template slot-scope="scope">
                                    <input type="text" v-model="scope.row.price"
                                        style=" width: 152px; height: 50px; background: #f3f3f3; border-radius: 10px; text-align: center; " />
                                </template>
                            </el-table-column>
                            <el-table-column prop="chengben" label="成本 批量设置" align="center">
                                <template slot-scope="scope">
                                    <input type="text" v-model="scope.row.chengben"
                                        style=" width: 152px; height: 50px; background: #f3f3f3; border-radius: 10px; text-align: center; " />
                                </template>
                            </el-table-column>
                            <el-table-column prop="updatetimecb" label="成本更新时间" align="center">
                                <template slot-scope="scope">
                                    {{ formatTimestamp(scope.row.updatetimecb) }}
                                </template>
                            </el-table-column>
                        </el-table>

                        <el-table :data="costList" style="width: 100%" :header-cell-style="headercellstyle" border
                            height="60vh" :key="'stencilTable'" v-if="importText === 'stencil'">
                            <!-- <el-table-column prop="headimgurl" align="center">
                <template slot-scope="scope">
                  <el-image
                    style="width: 50px"
                    :src="scope.row.headimgurl"
                    :preview-src-list="[scope.row.headimgurl]"
                  ></el-image>
                </template>
              </el-table-column> -->
                            <el-table-column prop="goodsname" label="商品名称" align="center"></el-table-column>
                            <el-table-column prop="skuid" label="商品SKU" align="center"></el-table-column>
                            <!-- <el-table-column
                prop="costset"
                label="快递模版 批量设置"
                align="center"
              >
                <template slot-scope="scope">
                  <el-select v-model="scope.row.costset" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column> -->
                            <el-table-column prop="kuaidi" label="快递费 批量设置" align="center">
                                <template slot-scope="scope">
                                    <input type="text" v-model="scope.row.kuaidi"
                                        style=" width: 152px; height: 50px; background: #f3f3f3; border-radius: 10px; text-align: center; " />
                                </template>
                            </el-table-column>
                            <el-table-column prop="updatetimekd" label="快递更新时间" align="center">
                                <template slot-scope="scope">
                                    {{ formatTimestamp(scope.row.updatetimekd) }}
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-table :data="costList" style="width: 100%" :header-cell-style="headercellstyle" border
                            height="60vh" :key="'packaTable'" v-if="importText === 'packa'">
                            <!-- <el-table-column prop="headimgurl" align="center">
                <template slot-scope="scope">
                  <el-image
                    style="width: 50px"
                    :src="scope.row.headimgurl"
                    :preview-src-list="[scope.row.headimgurl]"
                  ></el-image>
                </template>
              </el-table-column> -->
                            <el-table-column prop="goodsname" label="商品名称" align="center"></el-table-column>
                            <el-table-column prop="skuid" label="商品SKU" align="center"></el-table-column>
                            <el-table-column prop="costset" label="包装模版 批量设置" align="center">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.baozhuang" placeholder="请选择">
                                        <el-option v-for="item in bzList" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column
                prop="createtime"
                label="关联更新时间"
                align="center"
              ></el-table-column> -->
                            <el-table-column prop="updatetimebz" label="包装更新时间" align="center">
                                <template slot-scope="scope">
                                    {{ formatTimestamp(scope.row.updatetimebz) }}
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-table :data="costList" style="width: 100%" :header-cell-style="headercellstyle" border
                            height="60vh" :key="'freegiftTable'" v-if="importText === 'freegift'">
                            <el-table-column prop="goodsname" label="商品名称" align="center"></el-table-column>
                            <el-table-column prop="skuid" label="商品SKU" align="center"></el-table-column>
                            <el-table-column prop="costset" label="赠品模版 批量设置" align="center">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.costset" placeholder="请选择">
                                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                                            :value="item.value"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column
                prop="time"
                label="关联更新时间"
                align="center"
              ></el-table-column> -->
                            <el-table-column prop="zhongliang" label="赠品更新时间" align="center">
                                <template slot-scope="scope">
                                    {{ formatTimestamp(scope.row.zhongliang) }}
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-table :data="costList" style="width: 100%" :header-cell-style="headercellstyle" border
                            height="60vh" :key="'freegiftTable'" v-if="importText === 'weight'">
                            <el-table-column prop="goodsname" label="商品名称" align="center"></el-table-column>
                            <el-table-column prop="skuid" label="商品SKU" align="center"></el-table-column>
                            <el-table-column prop="costset" label="商品重量（KG） 批量设置" align="center">
                                <template slot-scope="scope">
                                    <input type="text" v-model="scope.row.zhongliang" style="
                      width: 152px;
                      height: 50px;
                      background: #f3f3f3;
                      border-radius: 10px;
                      text-align: center;
                    " />
                                </template>
                            </el-table-column>
                            <el-table-column prop="updatetimezl" label="重量更新时间" align="center">
                                <template slot-scope="scope">
                                    {{ formatTimestamp(scope.row.updatetimezl) }}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="vue_flex vue_flex_between vue_flex_center width_100" style="margin-top: 26px">

                        <div>
                            <el-button @click="dialogcostVisible = false"> 取消 </el-button>
                            <el-button type="primary" :loading="isButFlag" @click="confirmAdmin"> 保存当前页 </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { windowFun } from "@/utils/utils";
import DonMessage from "@/utils/message";
import Cookies from "js-cookie";
export default {
    components: { Pagination },
    data() {
        return {
            dpList: [],
            skuDiaflg: false,
            isButFlag: false,
            innerWidth: 0,
            innerHeight: 0,
            headercellstyle: {
                backgroundColor: "rgba(245, 247, 250, 1)",
                color: "rgba(51, 3, 0, 1)",
            },

            total: 0,
            listQuery: {
                page: 1,
                limit: 10,

                search: "",
            },
            skutotal: 0,
            skulistQuery: {
                page: 1,
                limit: 10,
                time: [],
                type: "",
                search: "",
                shopid: "",
                goodsid: "",
                minprice: "",
                maxprice: "",
                minchengben: "",
                maxchengben: "",
                minzhongliang: "",
                maxzhongliang: "",
            },

            dialogimportVisible: false,

            wenzi: "",
            dataList: [],

            options: [
                { value: "1", label: "淘宝" },
                { value: "2", label: "京东" },
                { value: "3", label: "拼多多" },
            ],
            tempObj: {
                channelVal: "",
                typeVal: "",
                shopid: "",
            },

            dialogcostVisible: false,
            importText: "cost",
            costList: [
                {
                    headimgurl:
                        "https://img2.baidu.com/it/u=2452821231,473003118&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
                    sku: "颜色分类:2*2米特厚6MM超声波小猪",
                    goodsbianma: "C001-006-009-001",
                    id: "5862350547617",
                    price: "79.9",
                    costset: "45.0000",
                    time: "2025-05-21 11:06:37",
                },
                {
                    headimgurl:
                        "https://img2.baidu.com/it/u=2452821231,473003118&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
                    sku: "颜色分类:2*2米特厚6MM超声波小猪",
                    goodsbianma: "C001-006-009-001",
                    id: "5862350547617",
                    price: "79.9",
                    costset: "45.0000",
                    time: "2025-05-21 11:06:37",
                },
                {
                    headimgurl:
                        "https://img2.baidu.com/it/u=2452821231,473003118&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
                    sku: "颜色分类:2*2米特厚6MM超声波小猪",
                    goodsbianma: "C001-006-009-001",
                    id: "5862350547617",
                    price: "79.9",
                    costset: "45.0000",
                    time: "2025-05-21 11:06:37",
                },
                {
                    headimgurl:
                        "https://img2.baidu.com/it/u=2452821231,473003118&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
                    sku: "颜色分类:2*2米特厚6MM超声波小猪",
                    goodsbianma: "C001-006-009-001",
                    id: "5862350547617",
                    price: "79.9",
                    costset: "45.0000",
                    time: "2025-05-21 11:06:37",
                },
            ],
            updatafileName: "",
            fileName: "",
            kdList: [],
            bzList: [],
            zpList: [],
        };
    },

    created() {
        this.innerWidth = windowFun().innerWidth;
        this.innerHeight = windowFun().innerHeight;
        this.getListFun();
        this.getdpListFun();
        for (let i = 1; i < 4; i++) {
            this.getbaozhuang(i);
        }

        // this.getSkuList();
    },

    methods: {
        // 删除（原有方法）
        handleDelete(row) {
            this.$confirm("您确定删除么?", "警告！", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                const res = await this.$http.get(this.$urls.delGoods, { goodsid: row.row.goodsid });
                console.log("----", res);
                if (res.errcode == 0) {
                    DonMessage.success("删除成功");
                    this.getListFun();
                } else {
                    DonMessage.error("删除失败");
                }
            })
                .catch((err) => {
                    console.log(err);
                });
        },
        downloadModel(url) {
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", "模板.xlsx");
            document.body.appendChild(link);
            link.click();
        },
        openSkuDia(row) {
            this.fileName = "";
            this.updatafileName = "";

            this.skuDiaflg = false;
        },
        async toApplySku() {
            if (!this.updatafileName) return DonMessage.error(`请上传文件`);
            let params = {
                file_path: this.updatafileName,
            };
            const res = await this.$http.post(this.$urls.addgoodsrolelist, params);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);

            DonMessage.success("添加成功");
            this.fileName = "";
            this.updatafileName = "";
            this.skuDiaflg = false;
        },
        // 设置弹窗
        openSetDia(type, item) {
            var map = JSON.parse(JSON.stringify(this.skulistQuery))
            this.skulistQuery = {
                minprice: "",
                maxprice: "",
                minchengben: "",
                maxchengben: "",
                minzhongliang: "",
                maxzhongliang: "",
                search: "",
                page: map.page,
                limit: map.limit,
                time: [],
                type:map.type,
                shopid: map.shopid,
                goodsid: map.goodsid,
            };
            this.importText = type;
            this.dialogcostVisible = true;
            this.skulistQuery.goodsid = item.goodsid;
            this.getSkuList();
        },

        async getbaozhuang(t) {
            const res = await this.$http.get(this.$urls.gettemplatelist, {
                page: "1",
                limit: "999",
                type: t,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            if (t == 1) return (this.kdList = res.list);
            if (t == 2) return (this.bzList = res.list);
            if (t == 3) return (this.zpList = res.list);
        },

        // 获取规格
        async getSkuList() {
            console.log("查询", this.skulistQuery)
            const res = await this.$http.post(
                this.$urls.getgoodsrolelist,
                this.skulistQuery
            );
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.costList = res.list;
        },
        closeGoodsDia() {
            this.fileName = "";
            this.updatafileName = "";
            this.tempObj = {
                channelVal: "",
                shopid: "",
            };
            this.skuDiaflg = false;
            this.dialogimportVisible = false;
        },
        // 添加商品
        async toApplyGoods() {
            if (!this.tempObj.channelVal) return DonMessage.error(`请选择渠道`);
            if (!this.tempObj.shopid) return DonMessage.error(`请选择店铺`);
            if (!this.updatafileName) return DonMessage.error(`请上传文件`);
            let params = {
                type: this.tempObj.channelVal,
                shopid: this.tempObj.shopid,
                file_path: this.updatafileName,
            };
            const res = await this.$http.post(this.$urls.addgoodslist, params);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.closeGoodsDia();
            this.getListFun();
        },
        qingchu() {
            this.skulistQuery = {
                page: 1,
                limit: 10,
                time: [],
                type: "",
                shopid: "",
                goodsid: "",
                minprice: "",
                maxprice: "",
                minchengben: "",
                maxchengben: "",
                minzhongliang: "",
                maxzhongliang: "",
                search: "",
            };
        },
        async leading(param, type) {
            this.listLoading = true;
            let fileObj = param.file;
            let uploadForm = new FormData();
            uploadForm.append("file", fileObj);

            const res = await this.$http.postfile(this.$urls.uploadFile, uploadForm);
            this.fileName = param.file.name;
            this.updatafileName = res.data.file_path;
        },
        // 店铺列表
        async getdpListFun() {
            const res = await this.$http.get(this.$urls.getshoplist, {
                page: 1,
                limit: 10000,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.dpList = res.list;
        },
        importTextFun(val) {
            let value = "";
            switch (val) {
                case "cost":
                    value = "商品成本设置";
                    break;
                case "stencil":
                    value = "快递模版设置";
                    break;
                case "packa":
                    value = "包装模板设置";
                    break;
                case "freegift":
                    value = "赠品模版设置";
                    break;
                case "weight":
                    value = "重量模版设置";
                    break;
            }
            return value;
        },

        async getListFun() {
            this.skulistQuery.starttime = this.skulistQuery.time.length > 0 ? this.listQuery.time[0] / 1000 : "";
            this.skulistQuery.endtime = this.skulistQuery.time.length > 0 ? this.listQuery.time[1] / 1000 : "";
            const res = await this.$http.get(this.$urls.getgoodslist, this.skulistQuery);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.dataList = res.list;
            this.total = res.count;
        },

        // 成本确定
        async confirmAdmin() {
            if (this.importText == "cost") {
                let params = [];
                for (let i in this.costList) {
                    let item = {
                        skuid: this.costList[i].skuid,
                        price: this.costList[i].price,
                        chengben: this.costList[i].chengben,
                    };
                    params.push(item);
                }
                // console.log(this.$urls.updateprice, '100000')
                // return
                const res = await this.$http.post(this.$urls.updateprice, {
                    data: JSON.stringify(params),
                });
                if (res.errcode != 0) return DonMessage.error(res.errmsg);
                this.getSkuList();
            }
            if (this.importText == "weight") {
                let params = [];
                for (let i in this.costList) {
                    let item = {
                        skuid: this.costList[i].skuid,
                        zhongliang: this.costList[i].zhongliang,
                    };
                    params.push(item);
                }
                const res = await this.$http.post(this.$urls.updatezhongliang, {
                    data: JSON.stringify(params),
                });
                if (res.errcode != 0) return DonMessage.error(res.errmsg);
                this.getSkuList();
            }
            if (this.importText == "packa") {
                let params = [];
                for (let i in this.costList) {
                    let item = {
                        skuid: this.costList[i].skuid,
                        baozhuang: this.costList[i].baozhuang,
                    };
                    params.push(item);
                }
                const res = await this.$http.post(this.$urls.updatebaozhuang, {
                    data: JSON.stringify(params),
                });
                if (res.errcode != 0) return DonMessage.error(res.errmsg);
                this.getSkuList();
            }
            if (this.importText == "freegift") {
                let params = [];
                for (let i in this.costList) {
                    let item = {
                        skuid: this.costList[i].skuid,
                        zengpin: this.costList[i].zengpin,
                    };
                    params.push(item);
                }
                const res = await this.$http.post(this.$urls.updatezengpin, {
                    data: JSON.stringify(params),
                });
                if (res.errcode != 0) return DonMessage.error(res.errmsg);
                this.getSkuList();
            }
            if (this.importText == "stencil") {
                let params = [];
                for (let i in this.costList) {
                    let item = {
                        skuid: this.costList[i].skuid,
                        kuaidi: this.costList[i].kuaidi,
                    };
                    params.push(item);
                }
                const res = await this.$http.post(this.$urls.updatekuaidi, {
                    data: JSON.stringify(params),
                });
                if (res.errcode != 0) return DonMessage.error(res.errmsg);
                this.getSkuList();
            }
        },
        formatTimestamp(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
            console.log('timestamp-->', timestamp);
            // 校验输入：确保时间戳是有效数字
            if (isNaN(timestamp) || timestamp == 0 || timestamp == null) {
                return '暂无';
            }

            // 十位时间戳（秒）转换为毫秒（JS Date对象需要毫秒级时间戳）
            const date = new Date(timestamp * 1000);

            // 补零函数：确保数字为两位数（如 5 → 05）
            const padZero = (num) => num.toString().padStart(2, '0');

            // 获取时间各部分
            const year = date.getFullYear(); // 四位年份
            const month = padZero(date.getMonth() + 1); // 月份（0-11 → 1-12）
            const day = padZero(date.getDate()); // 日期
            const hour = padZero(date.getHours()); // 小时（0-23）
            const minute = padZero(date.getMinutes()); // 分钟
            const second = padZero(date.getSeconds()); // 秒

            // 替换格式占位符，支持自定义格式
            return format.replace('YYYY', year)
                .replace('MM', month)
                .replace('DD', day)
                .replace('HH', hour)
                .replace('mm', minute)
                .replace('ss', second);
        },
    },
};
</script>

<style lang="scss" scoped>
.plateorder {
    padding: 22px;
}

.plateorder-tabs {
    background: rgba(245, 245, 245, 1);
    border-radius: 10px;
    padding: 9px 18px 8px 47px;

    .plateorder-tabs-input {
        .shaixuan_item {
            width: 350px;
            height: 54px;
            background: #ffffff;
            border-radius: 10px;
            padding: 0 20px;
            margin-right: 22px;

            .shaixuan_item_con {
                p {
                    font-size: 18px;
                }

                .shaixuan_item_arr {
                    width: 13px;
                    height: 8px;
                    margin-left: 10px;
                }

                .shaixuan_item_icon {
                    width: 29px;
                    height: 24px;
                    margin-right: 10px;
                }
            }
        }

        .top_bar_inp {
            width: 372px;
            height: 54px;
            background: rgba(255, 255, 255, 1);
            border-radius: 10px;
            margin-right: 32px;
            padding: 0 11px;

            .top_bar_inp_img1 {
                width: 24px;
                height: 24px;
                margin-right: 12px;
            }

            .top_bar_inp_inp {
                width: 282px;
            }
        }
    }

    .plateorder-tabs-bottom {
        margin-top: 25px;

        .plateorder-tabs-bottom-text {
            width: 159px;
            height: 40px;
            text-align: center;
            background: #ffffff;
            border-radius: 20px;
            font-size: 15px;
            line-height: 40px;
        }

        .plateorder-tabs-input-but {
            width: 131px;
            height: 54px;
            background: rgba(25, 92, 248, 1);
            border-radius: 10px;
            font-size: 20px;
            line-height: 54px;
            text-align: center;
        }

        .plain {
            background: rgba(255, 255, 255, 1);
            border-radius: 10px;
            border: 1px solid rgba(153, 153, 153, 1);
            line-height: 53px;
            margin-right: 31px;
        }
    }
}

.import-shop {
    background-image: url("../../../../../assets/yimou/tb.png");
    background-size: 100% 51px;

    .import-mask-boxs-img {
        margin-bottom: 21px;
        margin-top: 40px;

        img {
            width: 118px;
            height: auto;
        }

        .import-mask-boxs-img-view {
            width: fit-content;
            padding: 0px 14px 0px 17px;
            height: 68px;
            background: #f5f5f5;
            margin-top: 17px;
            border-radius: 10px;

            p {
                font-size: 18px;
                line-height: 18px;
            }

            div {
                width: 90px;
                height: 37px;
                margin-left: 48px;
                line-height: 37px;
                text-align: center;
                font-size: 14px;
                background: #195cf8;
                border-radius: 5px;
            }
        }

        .import-mask-boxs-img-text {
            font-size: 14px;
            line-height: 14px;
            margin-top: 11px;
        }
    }

    .import-mask-title {
        height: 51px;
        line-height: 51px;

        img {
            width: 13px;
            height: 13px;
            top: 21px;
            right: 20px;
        }
    }

    .import-mask-boxs {
        width: 650px;
        margin-top: 34px;

        .import-mask-boxs-inp {
            width: 100%;
            background: rgba(245, 245, 245, 1);
            border-radius: 10px;
            padding: 11px 22px;
            margin-bottom: 19px;

            ul {
                li:nth-of-type(1) {
                    width: 145px;
                    font-size: 18px;
                    line-height: 18px;

                    span {
                        color: rgba(255, 0, 0, 1);
                    }
                }
            }
        }

        .import-mask-boxs-img {
            margin-bottom: 21px;

            img {
                width: 118px;
                height: auto;
            }

            .import-mask-boxs-img-view {
                width: fit-content;
                padding: 0px 14px 0px 17px;
                height: 68px;
                background: #f5f5f5;
                margin-top: 17px;
                border-radius: 10px;

                p {
                    font-size: 18px;
                    line-height: 18px;
                }

                div {
                    width: 90px;
                    height: 37px;
                    margin-left: 48px;
                    line-height: 37px;
                    text-align: center;
                    font-size: 14px;
                    background: #195cf8;
                    border-radius: 5px;
                }
            }

            .import-mask-boxs-img-text {
                font-size: 14px;
                line-height: 14px;
                margin-top: 11px;
            }
        }

        .import-mask-boxs-upload {
            width: 100%;
            height: 168px;
            margin: 10px 0px 34px;
            background-image: url("../../../../../assets/yimou/hsk.png");

            img {
                width: 35px;
                height: 31px;
                margin-top: 39px;
            }

            .upload-title {
                font-size: 16px;
                line-height: 16px;
                margin: 16px 0px 13px;

                span:nth-of-type(2) {
                    color: rgba(20, 75, 201, 1);
                }
            }

            .upload-content {
                font-size: 14px;
                line-height: 14px;
            }
        }

        .import-mask-ul-boxs {
            width: 24vw;
        }
    }

    .import-mask-but {
        width: 266px;
        height: 47px;
        line-height: 47px;
        text-align: center;
        background: rgba(25, 92, 248, 1);
        border-radius: 10px;
        font-size: 17px;
    }
}

.cost-shop {
    background-image: url("../../../../../assets/yimou/tbc.png");
    background-size: 100% 68px;

    .import-mask-title {
        height: 68px;
        line-height: 68px;

        img {
            width: 12px;
            height: 12px;
            top: 29px;
            right: 26px;
        }
    }

    .cost-shop-boxs {
        padding: 0px 25px;

        .cost-shop-boxs-input {
            padding: 26px 0px 24px;

            .cost-shop-boxs-input-item {
                width: 322px;
                height: 50px;
                background: #f7f8fc;
                border-radius: 10px;
                padding: 0 11px;

                img {
                    width: 24px;
                    height: 24px;
                    margin-right: 12px;
                }
            }

            .shaixuan_item {
                width: 322px;
                height: 50px;
                background: rgba(247, 248, 252, 1);
                border-radius: 10px;
                padding: 0 18px;
                margin-left: 22px;

                .shaixuan_item_con {
                    p {
                        font-size: 17px;
                    }

                    .shaixuan_item_arr {
                        width: 13px;
                        height: 8px;
                        margin-left: 10px;
                    }

                    .shaixuan_item_icon {
                        width: 29px;
                        height: 24px;
                        margin-right: 10px;
                    }
                }

                .shaixuan_item_con:nth-of-type(2) {
                    margin-left: 57px;

                    p:nth-of-type(2) {
                        margin: 0px 20px;
                    }
                }
            }
        }
    }
}

.plateorder-type {
    margin: 23px 0px;

    div {
        width: 155px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        border-radius: 10px;
        margin-right: 14px;
    }

    .active {
        color: rgba(255, 255, 255, 1);
        background: rgba(25, 92, 248, 1);
    }

    .activenot {
        color: rgba(35, 35, 35, 1);
        background: rgba(245, 245, 245, 1);
    }
}

.import-mask-boxs-inp .el-input /deep/.el-input__inner {
    border: none !important;
    font-size: 18px;
}

.revenbook-drawer .el-input /deep/.el-input__inner {
    border: none !important;
    background: none !important;
    font-size: 18px;
}

.el-select {
    width: 100% !important;
}

.el-select /deep/.el-input__inner {
    width: 100%;
    border: none !important;
    background: none !important;
    font-size: 18px;
}

.el-select /deep/.el-select__caret {
    color: #000000 !important;
}

.upload-demo /deep/.el-upload-dragger {
    background: none !important;
    border: none !important;
    border-radius: 0px !important;
    width: 640px !important;
    height: 168px;
}

.shaixuan_item {
    .el-input /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }

    .el-input /deep/.el-input__prefix {
        display: none !important;
    }

    .el-select /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }
}

.plateorder-tabs-input-but-search {
    width: 131px;
    height: 54px;
    background: rgba(25, 92, 248, 1);
    border-radius: 10px;
    font-size: 20px;
    line-height: 54px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/goodsmanage/costset/index.vue